<div class="card">
        <div class="card-body">
            <div class="mb-3 d-flex align-items-center justify-content-between serach-btn-input">
                <h4 class="mb-2 fw-bolder">Projects List</h4>
                <div class="mb-2">
                    <input
                        type="text"
                        class="form-control mb-3"
                        placeholder="Search user by name"
                        (keyup)="updateFilter($event)"
                    />
                </div>
            </div>
            <div class="table-responsive">
                <ngx-datatable
                    #table
                    [rows]="projectList"
                    [columnMode]="columnMode"
                    [headerHeight]="50"
                    [footerHeight]="50"
                    [limit]="10"
                    [selected]="selected"
                    [selectionType]="SelectionType.checkbox"
                    (activate)="onActivate($event)"
                    [rowHeight]="rowHeight"
                    [scrollbarH]="true"
                >
                    
                    <ngx-datatable-column name="Sr. No." [width]="70">
                        <ng-template let-rowIndex="rowIndex" let-row="row" let-value="value" ngx-datatable-cell-template>
                            {{ rowIndex+1 }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Client Name" [width]="200">
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                            <div class="d-flex align-items-center">
                                <div class="">
                                    
                                    <div class="text-dark fw-bold" style="position: relative;"><span class="badge-dot me-2" style="position: absolute; left: -11px; top: 6px;" [ngClass]="row['isDemoLive'] === 'isDemo'? 'bg-warning': 'bg-success'"></span> {{row['clientName']}}</div>
                                    <div class="text-muted1">{{row['email']}}</div>
                                    <div class="text-muted1">{{row['phone']}}</div>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Industry" [width]="150">
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                            {{row['industry']}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Captain Email" [width]="200">
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                            {{row['captainEmail']}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Date" [width]="130">
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                           {{ row['demoStartDate'] | date: 'dd/MM/yyyy'}}{{row['liveDate'] | date: 'dd/MM/yyyy'}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Status" [width]="110">
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                            <div class="d-flex align-items-center" [ngClass]="row['status'] === true? 'text-success': 'text-danger'">
                                <span class="badge-dot me-2" [ngClass]="row['status'] === true? 'bg-success': 'bg-danger'"></span>
                                <span class="text-capitalize">{{row['status'] == true? 'Active':'Suspended'}}</span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <!-- <ngx-datatable-column name="Created At" [width]="120">
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                            {{row['created'] | date: 'dd/MM/yyyy'}}
                        </ng-template>
                    </ngx-datatable-column> -->
                    <ngx-datatable-column class="formNameCell" name="Form Name" [width]="170">
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                            <!-- {{row['inquires'] | json}} -->
                            <span class="multiRows" *ngFor="let data of row.inquires">
                                {{data.tableName}}
                            </span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Last Updated Time" [width]="170">
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                            <span class="multiRows" *ngFor="let data of row.inquires">
                                {{data.lastCreatedAt | date: 'dd/MM/yyyy'}}
                            </span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="No. Of Inquiries" [width]="150">
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                            <span class="multiRows" *ngFor="let data of row.inquires">
                                {{data.total}}
                            </span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [sortable]="false" cellClass="allow-overflow" [width]="60">
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                            <dropdown dropdownClass="d-block text-end ms-3" (click)="action.toggle($event)">
                                <a class="px-2" href="javascript:void(0)">
                                    <i class="feather icon-more-vertical"></i>
                                </a>
                                <dropdown-menu #action alignment="right">
                                    <a dropdownItem href="javascript:void(0)" (click)="editProject(row._id)">
                                        <div class="d-flex align-items-center">
                                           <svg _ngcontent-igh-c164="" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen"><path _ngcontent-igh-c164="" d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path _ngcontent-igh-c164="" d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"></path></svg>
                                            <span class="ms-2">Edit Project</span>
                                        </div>
                                    </a>
                                    <!-- <a dropdownItem href="javascript:void(0)" (click)="changePassword(row._id)">
                                        <div class="d-flex align-items-center">
                                           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield h-4 w-4 mr-2"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path></svg>
                                            <span class="ms-2">Re-Generate Password</span>
                                        </div>
                                    </a> -->
                                    <a dropdownItem href="javascript:void(0)" (click)="deleteProject(row._id)">
                                        <div class="d-flex align-items-center">
                                           <svg _ngcontent-dpi-c164="" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash2"><path _ngcontent-dpi-c164="" d="M3 6h18"></path><path _ngcontent-dpi-c164="" d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path><path _ngcontent-dpi-c164="" d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path><line _ngcontent-dpi-c164="" x1="10" x2="10" y1="11" y2="17"></line><line _ngcontent-dpi-c164="" x1="14" x2="14" y1="11" y2="17"></line></svg>
                                            <span class="ms-2">Delete Project</span>
                                        </div>
                                    </a>
                                </dropdown-menu>
                            </dropdown>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>









                <!-- <ngx-datatable
                    #myTable
                    class="bootstrap"
                    [rows]="rows"
                    [columnMode]="ColumnMode.force"
                    [headerHeight]="50"
                    [footerHeight]="50"
                    [limit]="10"
                    [rowHeight]="55"
                    [scrollbarV]="true"
                    [scrollbarH]="true"
                    (page)="onPage($event)">

                        <ngx-datatable-column *ngFor="let col of columns" [name]="col.name" [prop]="col.prop"  [flexGrow]="(col.prop == '_id')?1:3" [cellTemplate]="col.prop === '_id' ? idTemplate : (col.prop === 'created' ? createdTemplate : (col.prop === 'action' ? actionTemplate : (col.prop === 'demoStartDate' ? demoTemplate : undefined)))"></ngx-datatable-column>
                </ngx-datatable> -->
            </div>
        </div>
    </div>
<!-- <ng-template #idTemplate let-value="value" let-rowIndex="rowIndex" let-row="row">
    {{ rowIndex+1 }}
</ng-template>
<ng-template #demoTemplate let-value="value" let-rowIndex="rowIndex" let-row="row">
    {{ row.isDemoLive=='isDemo'? row.demoStartDate: row.liveDate | date:'dd-MM-yyyy'}}
</ng-template>
<ng-template #createdTemplate let-value="value" let-rowIndex="rowIndex" let-row="row">
    {{ row.created | date:'dd-MM-yyyy'}}
</ng-template>
<ng-template #actionTemplate let-value="value" let-rowIndex="rowIndex" let-row="row">
   <button class="btn btn-primary ml-2 circleBtn" type="button" ><i class="feather icon-edit"></i></button>
   <button class="btn btn-warning ml-2 circleBtn" type="button" ><i class="feather icon-trash"></i></button>
</ng-template> -->